import { render } from "./HomePasos.vue?vue&type=template&id=165a9fbc&scoped=true"
import script from "./HomePasos.vue?vue&type=script&lang=js"
export * from "./HomePasos.vue?vue&type=script&lang=js"

import "./HomePasos.vue?vue&type=style&index=0&id=165a9fbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165a9fbc"]])

export default __exports__